module.exports = __webpack_public_path__ + "media/bootstrap-icons/eye-slash-84849da0.svg";